<section class="px-lg md:px-6xl my-7xl">
  <div class="mb-5xl">
    <h3 class="font-extrabold mb-md md:text-header text-large text-primary-500">
      {{ 'landing_page_how_it_works_section_title' | transloco }}
    </h3>
    <p class="text-neutral-700 text-small">
      {{ 'landing_page_how_it_works_section_description' | transloco }}
    </p>
  </div>

  <div class="flex flex-col gap-5xl">
    @for (info of howItWorks; track info.title; let index = $index) {
      <mars-landing-card-img
        [badgeLabel]="index + 1 + ''"
        [image]="info.image"
        [title]="info.title | transloco"
        [description]="info.description | transloco"
        [position]="info.position" />
    }
  </div>
</section>
